import { useIntl } from 'react-intl';

import { Button, Typography } from '@bolteu/clay-react';

import { $tk } from 'utils/appTranslationKey';
import { ErrorIcon } from 'components/GenericErrorPage/icons/ErrorIcon';

interface GenericErrorPageProps {
  pageHeight?: string;
}

export function GenericErrorPage(props: GenericErrorPageProps) {
  const { formatMessage } = useIntl();
  const strings = {
    title: formatMessage({ id: $tk.components.GenericErrorPage.title }),
    text: formatMessage({ id: $tk.components.GenericErrorPage.text }),
    buttonText: formatMessage({ id: $tk.components.GenericErrorPage.buttonText }),
  };

  const actions = {
    onTryAgain: () => {
      window.location.reload();
    },
  };
  const handleOnTryAgain = () => {
    actions.onTryAgain();
  };

  return (
    <div
      className="flex flex-col flex-nowrap items-center justify-center gap-8 pb-8"
      style={{ height: props.pageHeight ?? '100vh' }}
    >
      <ErrorIcon />
      <div className="flex flex-col gap-4">
        <Typography defaultTag="h5" className="bolt-font-heading-s-accent text-center">
          {strings.title}
        </Typography>
        <Typography className="max-w-[424px] text-center">{strings.text}</Typography>
      </div>
      <Button size="md" onClick={handleOnTryAgain}>
        {strings.buttonText}
      </Button>
    </div>
  );
}
